module.exports = __webpack_public_path__ + "img/nei.c59ea7af.png";